import { toggleTodoExpanded } from '../../moduleServices/planner_todos_api';
import { toast } from 'react-hot-toast';

// ##### Custom hook for todo toggle functionality
export const useTodoToggle = (todo, setTodo) => {
  // ##### Handle card toggle with optimistic update
  const handleCardToggle = async (todoId) => {
    // Find the current todo
    const currentTodo = todo.find(todoItem => todoItem.id === todoId);
    if (!currentTodo) return;

    // Optimistic update - immediately update UI
    const newExpandedState = !currentTodo.is_expanded;
    setTodo(prev => prev.map(todoItem => 
      todoItem.id === todoId 
        ? { ...todoItem, is_expanded: newExpandedState }
        : todoItem
    ));

    try {
      // Call API to sync with backend
      await toggleTodoExpanded(todoId);
      console.log('Todo expanded state synced with backend');
    } catch (error) {
      console.error('Error syncing todo expanded state:', error);
      
      // Revert optimistic update on error
      setTodo(prev => prev.map(todoItem => 
        todoItem.id === todoId 
          ? { ...todoItem, is_expanded: currentTodo.is_expanded }
          : todoItem
      ));
      
      toast.error('Failed to update todo state. Please try again.', { closeButton: true });
    }
  };

  return {
    handleCardToggle
  };
};
